if (typeof document === "undefined") return;
var createStylesheet = function(chunkId, fullhref, oldTag, resolve, reject) {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	var onLinkComplete = function(event) {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;

	if (oldTag) {
		oldTag.parentNode.insertBefore(linkTag, oldTag.nextSibling);
	} else {
		document.head.appendChild(linkTag);
	}
	return linkTag;
};
var findStylesheet = function(href, fullhref) {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = function(chunkId) {
	return new Promise(function(resolve, reject) {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, null, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	"umi": 0
};

__webpack_require__.f.miniCss = function(chunkId, promises) {
	var cssChunks = {"src_umi_umi_ts":1,"p__user__Login__index":1,"p__TrangChu__index":1,"p__TienIch__GioiThieu__index":1,"p__SetupPlan__index":1,"src_features_signing_styles_signing-mobile_less":1,"src_features_signing_components_index_ts":1,"p__YeuCauKy__index":1,"p__QuanLyChuKy__index":1,"p__XacMinhChuKy__index":1,"p__KySoTapTrung__index":1,"p__LichSuKySo__index":1,"umi__plugin-layout__Layout":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(function() {
			installedCssChunks[chunkId] = 0;
		}, function(e) {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

var oldTags = [];
var newTags = [];
var applyHandler = function(options) {
	return { dispose: function() {
		for(var i = 0; i < oldTags.length; i++) {
			var oldTag = oldTags[i];
			if(oldTag.parentNode) oldTag.parentNode.removeChild(oldTag);
		}
		oldTags.length = 0;
	}, apply: function() {
		for(var i = 0; i < newTags.length; i++) newTags[i].rel = "stylesheet";
		newTags.length = 0;
	} };
}
__webpack_require__.hmrC.miniCss = function(chunkIds, removedChunks, removedModules, promises, applyHandlers, updatedModulesList) {
	applyHandlers.push(applyHandler);
	chunkIds.forEach(function(chunkId) {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		var oldTag = findStylesheet(href, fullhref);
		if(!oldTag) return;
		promises.push(new Promise(function(resolve, reject) {
			var tag = createStylesheet(chunkId, fullhref, oldTag, function() {
				tag.as = "style";
				tag.rel = "preload";
				resolve();
			}, reject);
			oldTags.push(oldTag);
			newTags.push(tag);
		}));
	});
}